export default {
    '--full-color': '#C2B8B0',
    '--light-color': '#C2B8B099',
    '--main-content-grid': '#D1CBC5',
    '--title-color':'#9B8C82',
    '--icon-color': '#B7A99D',
    '--grid-bg-color': 'rgba(0,0,0,0.06)',
    '--text-input-bg-color': 'rgba(245,240,230,0.85)',
    '--avatar-background': 'linear-gradient(to right, #C2B8B099, #C2B8B0)',
    '--reserve-background': '#B7A99D',
    '--icon-theme-filter': 'invert(40%) sepia(60%) saturate(350%) hue-rotate(350deg) brightness(95%) contrast(98%)',
    '--login-layout-background': 'linear-gradient(135deg,#D1CBC5 0%,#D1CBC5 100%)',
    '--lbl-focused-color': '#2A231C',
    '--focused-fieldset-color': 'rgba(42,35,28,0.5)',
    '--input-border-error-color': '#B63A24',
    '--checkbox-color': '#2A231C',
    '--color-white': '#ffffff',
    '--txt-disabled': '#C4B8A7',
    '--txt-success': '#9B8C82',
    '--txt-error': 'rgba(255,125,98,0.7)',
    '--disabled-bg': 'rgba(255,86,86,0.03)',
    '--txt-default': '#706455',
    '--link-color': '#2A231C',
    '--txt-gray-color': 'rgba(150,140,120,1)',
    '--active-box-background': '#B7A99D',
    '--scrollbar-bg': '#D9C9B6',
    '--active-item-background-color': 'rgba(210,179,138,0.15)',
    '--input-number-border-color': 'rgba(180,170,150,0.7)',
    '--input-number-focused-border-color': '#9B8C82',
    '--grid-view-background': '#FFFFFF',
    '--card-view-background': '#FFFFFF',
    '--btn-bg-hover': '#C2B8B0',
    '--btn-success-background': '#C2B8B0',
    '--btn-success-border-color': '#9B8C82',
    '--btn-gray-background-color': 'rgba(73,73,73,0.18)',
    '--btn-gray-border-color': '#D8D8D8',
    '--btn-disabled-border-color': '#E8E8E8',
    '--tab-background': '#D2B38A',
    '--tab-indicator-background': 'transparent',
    '--tab-shadow': '0 4px 10px rgba(0,0,0,0.12)',
    '--btn-shadow': '0 4px 14px rgba(0,0,0,0.16)',
    '--card-shadow': '0 4px 10px rgba(0,0,0,0.09)',
    '--input-background-color': '#F4EFE8',
    '--select-border-color': 'rgba(150,130,110,0.7)',
    '--select-bg-color': '#FFFFFF',
    '--select-text-color': '#2A231C',
    '--loading-color': '#2A231C',
};